module.exports = __webpack_public_path__ + "static/media/Rubius logo_горизонтальный белый.4b630598.png";